import http from "../http-common";
import authHeader from './auth-header';

class userManagementService {
  getAllUsers() {
    return http.get("/user_management", { headers: authHeader() });
  }

  getAllRoles() {
    return http.get("/roles", { headers: authHeader() });
  }

  getUser(SecurityUserID) {
    return http.get(`/user_management/${SecurityUserID}`, { headers: authHeader() });
  }

  addUser_Role(SecurityUserID, data) {
    return http.put(`/user_management/add_roles/${SecurityUserID}`, data, { headers: authHeader() });
  }

  removeUser_Role(SecurityUserID, data) {
    return http.put(`/user_management/remove_roles/${SecurityUserID}`, data, { headers: authHeader() });
  }

  updateUser(SecurityUserID, data) {
    return http.put(`/user_management/update/${SecurityUserID}`, data, { headers: authHeader() });
  }

  changePassword(SecurityUserID, data) {
    return http.put(`/user_management/change_password/${SecurityUserID}`, data, { headers: authHeader() });
  }

  deleteUser(SecurityUserID) {
    return http.delete(`/user_management/${SecurityUserID}`, { headers: authHeader() });
  }

  findByUsername(FullName) {
    return http.get(`/user_management/?username=${FullName}`, { headers: authHeader() });
  }
}

export default new userManagementService();